<template>
  <q-modal
    class="sl-modal"
    id="confirmModak"
    :maximized="false"
    :value="isOpen"
    @hide="closeModal"
  >
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
        <q-icon name="fa fa-info-circle" />
        {{ title }}
      </q-toolbar-title>
      <q-icon @click.native="closeModal" name="clear" />
    </q-toolbar>
    <div style="padding:20px">
      <strong>{{ body }}</strong>
    </div>
    <q-toolbar slot="footer">
      <q-toolbar-title></q-toolbar-title>
      <q-btn color="green" @click.native="onOk()" :label="confirmText" />&nbsp;
      <q-btn outline color="faded" @click.native="closeModal" :label="cancelText" />
    </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "ConfirmModal",
  props: {
    isOpen: Boolean,
    closeModal: Function,
    onOk: Function,
    title: String,
    body: String,
    confirmText: { default: "OK" },
    cancelText: { default: "Cancel" },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
    })
  },
  components: {
  },
  valdiations(){
    return {}
  },
  methods: {
  }
};
</script>

<style lang="stylus">
</style>